import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FieldArray from "./helper/fieldArray";
import moment from "moment";
import { Message, Button, Form, Icon, Container, Grid } from "semantic-ui-react";
import { socket } from "../../../App";

import { useSelector, useDispatch } from "react-redux";
import {
  selectPatientelleGrid,
  fetch_products,
} from "../../../features/patientelle/patientelleSlice";
import { toast } from "react-toastify";

import { One_user_actes_per_Day, getDoctors } from "../../Api/api";

import { useQuery, useMutation } from "react-query";
import { useLocation } from "react-router-dom";
import { remove_prod_from_user, Add_Products_To_user } from "../../Api/api";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"

const AddToWaitingList = (props) => {
  const [time, setTime] = useState(false)
  const [time2, setTime2] = useState(false)
  const location = useLocation();
  const [myLocation, setMylocation] = useState();
  const PatientelleGridState = useSelector(selectPatientelleGrid);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    idpatient,
    nom,
    prenom,
    civilite,
    date_naissance,
    commentaire_sur_patient,
    fk_id_medecin
  } = PatientelleGridState;
  sessionStorage.setItem("ID_Session", idpatient);


  useEffect(() => {
    setMylocation(location.pathname);
  }, [location]);

  const defaultValues = {
    products: [
      {
        idpatient,
        fk_id_acte: "0",
      },
    ],
  };

  const { control, register, handleSubmit, getValues, errors, setValue } =
    useForm();

  useEffect(() => {
    function receivedMessage(m) {
      refetch();
    }

    socket.on("add", receivedMessage);
    socket.on("delete", receivedMessage);
    socket.on("update", receivedMessage);
    socket.on("transfer", receivedMessage);
    return () => {
      socket.off("add", receivedMessage);
      socket.on("delete", receivedMessage);
      socket.off("update", receivedMessage);
      socket.off("transfer", receivedMessage);
    };
    // eslint-disable-next-line
  }, []);
  let Todaydate = moment().format("YYYY-MM-DD");
  const { data, refetch } = useQuery(
    "liste_dattente",
    () => {
      return One_user_actes_per_Day(idpatient, Todaydate, fk_id_medecin);
    },
    {
      onSuccess: (data) => {
        dispatch(fetch_products(data));
      },
    }
  );
  //

  if (time) {
    setTimeout(() => setTime(false), 3000);
  }
  if (time2) {
    setTimeout(() => setTime2(false), 500);
  }
  const onSubmitt = async (data) => {

    if (data.fk_id_medecin1 === "") {
      data.fk_id_medecin1 = fk_id_medecin
    }
    Add_prod_User_mutation.mutate(data);
    setTime(true)
  };

  const Add_prod_User_mutation = useMutation(
    (data) => {
      Add_Products_To_user(data);
    },
    {
      onSuccess: (data) => {
        toast.success("Successfully updated", {
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => refetch(), 300);
        setTimeout(() => refetch(), 500);
        setTimeout(
          () =>
            socket.emit("add", {
              civilite,
              nom,
              prenom,
              actionTypeSocket: "a été ajouté",
            }),

          30
        );
      },
      onError: () => {
        console.log("error");
      },
    }
  );
  const Remove_prod_User_mutation = useMutation(
    (data) => {
      remove_prod_from_user(data);
      setTime2(true)
    },
    {
      onSuccess: (data) => {
        toast.success("Successfully updated", {
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => refetch(), 300);
        setTimeout(() => refetch(), 500);
        socket.emit("delete", data);
      },
      onError: () => {
        console.log("error");
      },
    }
  );

  const GetAllDoctors = useQuery("GetAllDoctors", () =>
    getDoctors()
  );

  let Doctors_list = "";

  if (GetAllDoctors?.data) {
    Doctors_list = GetAllDoctors?.data.map((item, index) => (
      <option className="item" key={index} value={item.idAuth}>
        {item.user_name}
      </option>
    ));
  }

  return (
    <>

      <Container>
        <Form onSubmit={handleSubmit(onSubmitt)}>
          {myLocation === "/Consultation" ? null : (
            <>
              <br></br>
              <h1>Vous pouvez ajouter une ou plusieurs prestations</h1>
              <h3>
                JE SUIS {civilite} {nom} {prenom} <br></br> Date de naissance :{" "}
                {date_naissance}
              </h3>
            </>
          )}

          {data?.map(
            (
              {
                fk_id_acte,
                fk_id_patient1,
                date_consultation,
                nom_acte,
                prix_acte,
                suplement,
                remise,
                fk_id_medecin1
              },
              idx
            ) => (
              <ul
                key={fk_id_acte}
                style={{
                  paddingInlineStart: "1rem",
                  fontWeight: "bolder",
                }}
              >
                <span className="hoverEffect">
                  <Icon
                    onClick={() =>
                      Remove_prod_User_mutation.mutate({
                        fk_id_acte,
                        fk_id_patient1,
                        date_consultation,
                        fk_id_medecin1
                      })
                    }
                    circular
                    name="delete"
                    inverted
                    color="red"
                    disabled={time2}
                  />
                </span>{" "}
                <span className="AddProps">
                  {" "}
                  - {idx + 1} - {nom_acte} : {prix_acte + suplement - remise}{" "}
                </span>
              </ul>
            )
          )}
          {commentaire_sur_patient ? (
            <Message color="red">
              <Message.Header>Important!</Message.Header>
              {commentaire_sur_patient}
            </Message>
          ) : null}
          <input
            hidden={true}
            maxLength={40}
            type="text"
            defaultValue={idpatient}
            {...register("idpatient")}
          />
          <Grid.Row className="MycssCustom">

            <div className="required field" >
              {" "}
              <label>Date de consultation</label>{" "}
              <div className="ui input">
                {" "}
                <input
                  defaultValue={Todaydate}
                  type="date"
                  name="date_consultation"
                  required
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_consultation")}
                ></input>{" "}
              </div>{" "}
            </div>


            <div
              className="required field"
              style={{ paddingLeft: "0" }}
            >
              <label>Medecin</label>{" "}
              <select
                defaultValue={fk_id_medecin}
                // role="listbox"
                aria-expanded="false"
                className="ui selection dropdown prodItem"
                required
                {...register(`fk_id_medecin1`)}
              >
                {/* <option className="item" value={0}>
                  Choisissez un médecin
                </option> */}
                {Doctors_list}

              </select>
            </div>


          </Grid.Row>


          <FieldArray
            {...{ control, register, defaultValues, getValues, setValue, errors }}
          />
          <br></br>
          <br></br>
          <Button positive type="submit" disabled={time}>
            OK
          </Button>
        </Form>

        {location.pathname === "/Consultation" ? null : <SpeedDialComponent />}
      </Container>
      {location.pathname === "/Consultation" ? null : <br></br>}
      {location.pathname === "/Consultation" ? null : <br></br>}
      {location.pathname === "/Consultation" ? null : <br></br>}
      {location.pathname === "/Consultation" ? null : <br></br>}
    </>
  );
};

export default AddToWaitingList;
